module.exports = __webpack_public_path__ + "img/logo-shiba888.c386bfd2.png";